<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 sm:gap-8 px-2 sm:px-3">
    @if (loading()) {
      <p class="text-sm text-gray-500">Chargement du tableau de bord...</p>
    } @else if (error()) {
      <div class="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800">
        Impossible de charger le tableau de bord.
        <button type="button" class="ml-2 underline" (click)="load()">Réessayer</button>
      </div>
    } @else if (dashboard(); as d) {
      @if (compte(); as compteData) {
        <header class="min-w-0">
          <h1 class="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">Tableau de bord</h1>
          <p class="text-sm text-gray-500 mt-1 break-words">
            {{ d.nomEntreprise }}
            @if (!d.entrepriseActive) {
              <span class="text-red-600 font-medium"> — Entreprise cessée</span>
            }
          </p>
          <p class="text-xs text-gray-400 mt-1 font-mono break-all">SIREN {{ d.siren }} · SIRET {{ d.siret }}</p>
        </header>

        @if (!executiveSubscriptionState.isFreeExecutive()) {
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <button
              type="button"
              [routerLink]="['/dashboard', 'company', siret, 'attestations']"
              class="rounded-2xl border border-gray-200 bg-white p-5 shadow-card text-left hover:border-secondary/30 transition-colors w-full cursor-pointer"
            >
              <div class="flex items-start justify-between mb-3">
                <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                  <span class="material-symbols-outlined text-secondary text-[22px]">gavel</span>
                </div>
                <span class="text-[11px] font-medium px-2 py-0.5 rounded-full"
                      [class.bg-green-100]="d.hasRegulariteFiscale || d.hasAvisCfe"
                      [class.text-green-700]="d.hasRegulariteFiscale || d.hasAvisCfe"
                      [class.bg-red-100]="!(d.hasRegulariteFiscale || d.hasAvisCfe)"
                      [class.text-red-700]="!(d.hasRegulariteFiscale || d.hasAvisCfe)">
                  {{ d.hasRegulariteFiscale || d.hasAvisCfe ? 'Récupéré' : 'Non récupéré' }}
                </span>
              </div>
              <h2 class="text-sm font-semibold text-gray-900 mb-1">Dette fiscale</h2>
              <p class="text-xs text-gray-500">
                {{ d.hasRegulariteFiscale || d.hasAvisCfe ? 'Montant à récupérer sur impots.gouv' : 'Non encore récupérée sur impots.gouv' }}
              </p>
            </button>

            <button
              type="button"
              [routerLink]="['/dashboard', 'company', siret, 'attestations']"
              class="rounded-2xl border border-gray-200 bg-white p-5 shadow-card text-left hover:border-secondary/30 transition-colors w-full cursor-pointer"
            >
              <div class="flex items-start justify-between mb-3">
                <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                  <span class="material-symbols-outlined text-secondary text-[22px]">task_alt</span>
                </div>
                <span class="text-[11px] font-medium px-2 py-0.5 rounded-full"
                      [class.bg-green-100]="d.hasRegulariteFiscale"
                      [class.text-green-700]="d.hasRegulariteFiscale"
                      [class.bg-red-100]="!d.hasRegulariteFiscale"
                      [class.text-red-700]="!d.hasRegulariteFiscale">
                  {{ d.hasRegulariteFiscale ? 'Récupéré' : 'Non récupéré' }}
                </span>
              </div>
              <h2 class="text-sm font-semibold text-gray-900 mb-1">Régularité fiscale</h2>
              <p class="text-xs text-gray-500">
                {{ d.hasRegulariteFiscale ? 'Attestation disponible' : 'Attestation non récupérée — impots.gouv' }}
              </p>
            </button>

            <button
              type="button"
              [routerLink]="['/dashboard', 'company', siret, 'attestations']"
              class="rounded-2xl border border-gray-200 bg-white p-5 shadow-card text-left hover:border-secondary/30 transition-colors w-full cursor-pointer"
            >
              <div class="flex items-start justify-between mb-3">
                <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                  <span class="material-symbols-outlined text-secondary text-[22px]">shield</span>
                </div>
                <span class="text-[11px] font-medium px-2 py-0.5 rounded-full"
                      [class.bg-green-100]="d.hasUrssafAttestation"
                      [class.text-green-700]="d.hasUrssafAttestation"
                      [class.bg-red-100]="!d.hasUrssafAttestation"
                      [class.text-red-700]="!d.hasUrssafAttestation">
                  {{ d.hasUrssafAttestation ? 'Récupéré' : 'Non récupéré' }}
                </span>
              </div>
              <h2 class="text-sm font-semibold text-gray-900 mb-1">Attestation URSSAF</h2>
              <p class="text-xs text-gray-500">
                {{ d.hasUrssafAttestation ? 'Attestation disponible' : 'Attestation non récupérée — urssaf.fr' }}
              </p>
            </button>

            <button
              type="button"
              [routerLink]="['/dashboard', 'company', siret, 'kbis']"
              class="rounded-2xl border border-gray-200 bg-white p-5 shadow-card text-left hover:border-secondary/30 transition-colors w-full cursor-pointer"
            >
              <div class="flex items-start justify-between mb-3">
                <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                  <span class="material-symbols-outlined text-secondary text-[22px]">description</span>
                </div>
                <span class="text-[11px] font-medium px-2 py-0.5 rounded-full"
                      [class.bg-green-100]="d.hasKbis"
                      [class.text-green-700]="d.hasKbis"
                      [class.bg-red-100]="!d.hasKbis"
                      [class.text-red-700]="!d.hasKbis">
                  {{ d.hasKbis ? 'Récupéré' : 'Non récupéré' }}
                </span>
              </div>
              <h2 class="text-sm font-semibold text-gray-900 mb-1">KBIS</h2>
              <p class="text-xs text-gray-500">
                {{ d.hasKbis ? 'Document disponible' : 'Document non récupéré — infogreffe.fr' }}
              </p>
            </button>
          </div>
        }

        @if (executiveSubscriptionState.isFreeExecutive()) {
          <article class="rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 shadow-card min-w-0">
            <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4">
              <div class="flex items-start gap-3 min-w-0">
                <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0">
                  <span class="material-symbols-outlined text-secondary text-[22px]">link</span>
                </div>
                <div class="min-w-0">
                  <h2 class="text-sm font-semibold text-gray-900">Connexions</h2>
                  <p class="text-xs text-gray-500">Identifiants Impots.gouv pour récupérer automatiquement vos informations fiscales</p>
                </div>
              </div>
              @if (hasImpotsCredentials()) {
                <span class="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded self-start">Configuré</span>
              } @else {
                <span class="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded self-start">Non configuré</span>
              }
            </div>

            <p class="text-xs text-gray-600 mb-4 rounded-lg border border-blue-100 bg-blue-50 px-3 py-2">
              En renseignant vos identifiants Impots.gouv, Attestio récupérera automatiquement vos informations fiscales (dette fiscale, calendrier TVA).
            </p>

            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <span class="text-sm font-medium text-gray-700">Impots.gouv</span>
                @if (hasImpotsCredentials()) {
                  <button type="button" (click)="deleteImpotsCredentials()" class="text-red-400 hover:text-red-600" title="Supprimer">
                    <lucide-icon [name]="X" size="14"></lucide-icon>
                  </button>
                }
              </div>
              <div class="flex flex-col sm:flex-row gap-2">
                <input
                  type="text"
                  placeholder="Identifiant"
                  class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-secondary"
                  [value]="passwordForm().nomUtilisateurImpotsGouv ?? ''"
                  (input)="updateImpotsField('nomUtilisateurImpotsGouv', $any($event.target).value)"
                />
                <div class="relative flex-1">
                  <input
                    [type]="showPasswordImpots() ? 'text' : 'password'"
                    placeholder="Mot de passe"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-1 focus:ring-secondary"
                    [value]="passwordForm().passwordImpotsGouv ?? ''"
                    (input)="updateImpotsField('passwordImpotsGouv', $any($event.target).value)"
                  />
                  <button
                    type="button"
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    (click)="showPasswordImpots.set(!showPasswordImpots())"
                  >
                    <lucide-icon [name]="showPasswordImpots() ? EyeOff : Eye" size="14"></lucide-icon>
                  </button>
                </div>
              </div>
              <div class="flex justify-stretch sm:justify-end">
                <button
                  type="button"
                  class="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-white hover:bg-secondary-hover disabled:opacity-50 cursor-pointer"
                  [disabled]="savingImpotsCredentials()"
                  (click)="saveImpotsCredentials()"
                >
                  <lucide-icon [name]="Save" size="14"></lucide-icon>
                  @if (savingImpotsCredentials()) { Enregistrement... } @else { Enregistrer }
                </button>
              </div>
            </div>
          </article>
        } @else {
          <a
            [routerLink]="['/dashboard', 'company', siret, 'attestations']"
            fragment="identifiants-plateformes"
            class="card-interactive block no-underline text-inherit cursor-pointer w-full"
          >
            <div class="flex items-start justify-between mb-3">
              <div class="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                <span class="material-symbols-outlined text-secondary text-[22px]">link</span>
              </div>
            </div>
            <h2 class="text-sm font-semibold text-gray-900 mb-1">Connexions</h2>
            <p class="text-xs text-gray-500 mb-3">Identifiants pour la récupération automatique</p>
            <ul class="text-xs text-gray-600 space-y-1.5">
              <li class="flex justify-between gap-2"><span>URSSAF</span><span [class.text-green-600]="d.credentialsUrssafConfigured" [class.text-gray-400]="!d.credentialsUrssafConfigured">{{ d.credentialsUrssafConfigured ? 'Configuré' : 'Non configuré' }}</span></li>
              <li class="flex justify-between gap-2"><span>Impots.gouv</span><span [class.text-green-600]="d.credentialsImpotsConfigured" [class.text-gray-400]="!d.credentialsImpotsConfigured">{{ d.credentialsImpotsConfigured ? 'Configuré' : 'Non configuré' }}</span></li>
              <li class="flex justify-between gap-2"><span>MonIdenum</span><span [class.text-green-600]="d.credentialsIdenumConfigured" [class.text-gray-400]="!d.credentialsIdenumConfigured">{{ d.credentialsIdenumConfigured ? 'Configuré' : 'Non configuré' }}</span></li>
            </ul>
          </a>
        }

        <div class="rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 shadow-card min-w-0">
          <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-5">
            <div class="flex items-center gap-3 min-w-0">
              <div class="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center shrink-0">
                <span class="material-symbols-outlined text-white">apartment</span>
              </div>
              <div class="min-w-0">
                <h2 class="font-display text-base sm:text-lg font-semibold text-gray-900 break-words">{{ d.nomEntreprise }}</h2>
                <p class="text-xs text-gray-500 break-all">SIRET : {{ d.siret }}</p>
              </div>
            </div>
            <div class="flex flex-col xs:flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
              @if (mobilePlatform() === 'ios') {
                <button
                  type="button"
                  (click)="downloadApplePass()"
                  class="inline-flex items-center justify-center gap-1.5 rounded-lg bg-black px-3 py-2 text-sm font-medium text-white hover:bg-gray-800 cursor-pointer"
                  aria-label="Ajouter à Apple Wallet"
                >
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  Apple Wallet
                </button>
              }
              <a
                [routerLink]="['/dashboard', 'company', siret, 'wallet']"
                class="inline-flex items-center justify-center gap-1 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-secondary hover:text-white no-underline"
              >
                <span class="material-symbols-outlined text-[18px]">wallet</span>
                Mon Wallet
              </a>
            </div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            <div>
              <span class="text-gray-500">Forme juridique</span>
              <p class="font-medium text-gray-900">{{ compteData.company.companyDetailResponse.formeJuridique || '—' }}</p>
            </div>
            <div>
              <span class="text-gray-500">Code NAF</span>
              <p class="font-medium text-gray-900">{{ compteData.company.companyDetailResponse.codeNaf || '—' }}</p>
            </div>
            <div>
              <span class="text-gray-500">Dirigeant</span>
              <p class="font-medium text-gray-900">
                {{ compteData.company.companyDetailResponse.dirigeant ? compteData.company.companyDetailResponse.dirigeant : '—' }}
              </p>
            </div>
            <div>
              <span class="text-gray-500">Entreprise</span>
              <p class="font-medium text-gray-900">{{ compteData.company.companyDetailResponse.domaineActivite || '—' }}</p>
            </div>
          </div>
        </div>

        @if (!executiveSubscriptionState.isFreeExecutive()) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a
              [routerLink]="['/dashboard', 'company', siret, 'dossier-fiscal']"
              class="rounded-2xl border border-gray-200 bg-white flex flex-col items-center gap-2 py-5 px-4 text-center shadow-card hover:border-secondary/30 hover:shadow-card-hover transition-all duration-200 no-underline text-inherit w-full cursor-pointer"
            >
              <span class="material-symbols-outlined text-secondary text-2xl">description</span>
              <span class="text-sm font-medium text-gray-900">Dossier fiscal</span>
              <span class="text-xs text-gray-500">CFE, taxes, TVA, IS</span>
            </a>
            <a
              [routerLink]="['/dashboard', 'company', siret, 'documents']"
              class="rounded-2xl border border-gray-200 bg-white flex flex-col items-center gap-2 py-5 px-4 text-center shadow-card hover:border-secondary/30 hover:shadow-card-hover transition-all duration-200 no-underline text-inherit w-full cursor-pointer"
            >
              <span class="material-symbols-outlined text-secondary text-2xl">arrow_forward</span>
              <span class="text-sm font-medium text-gray-900">Mes documents</span>
              <span class="text-xs text-gray-500">Gérer et consulter vos fichiers</span>
            </a>
          </div>
        }
      }
    }
  </div>
</section>
